import { useDispatch } from 'react-redux'
import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import { Box } from '@mui/material'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import DateCustom from '../../../components/atoms/input/DateCustom'
import { toastHelper } from '../../../util/toastHelper'
import SwitchBtn from '../../../components/atoms/switch-btn/SwicthBtn'
import {
	updateKazoo,
	fetchKazooDetailsNew,
} from '../../../features/kazooEventSlice'

function toDateValue(val) {
	if (!val) return null
	if (val?.$d instanceof Date) return val.$d
	if (val instanceof Date) return val
	if (typeof val === 'string') return new Date(val)
	return null
}

function WeddingDate({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
	kazooId,
	mode,
}) {
	const dispatch = useDispatch()
	const setMultiDay = (bool) => {
		setWeddingData({
			...weddingData,
			multiDay: bool,
		})
	}

	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>Do you have a wedding date in mind?</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<Box data-cy="date" className={styles.formInputs}>
								<SwitchBtn
									size="lg"
									label="Multi-day wedding"
									checked={weddingData.multiDay}
									setChecked={setMultiDay}
								/>
								{weddingData.multiDay ? (
									<DateCustom
										isRange
										startName="startDate"
										endName="endDate"
										setDataFunction={setWeddingData}
										data={weddingData}
									/>
								) : (
									<DateCustom
										value={weddingData.startDate}
										name="startDate"
										setDataFunction={setWeddingData}
										data={weddingData}
									/>
								)}
							</Box>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={async () => {
						const today = new Date()

						if (weddingData.multiDay) {
							if (!weddingData.startDate)
								return toastHelper(
									'Start date is required',
									'error'
								)
							if (!weddingData.endDate)
								return toastHelper(
									'End date is required',
									'error'
								)
							if (
								today > weddingData.startDate?.$d ||
								today > weddingData.endDate?.$d
							)
								return toastHelper(
									'Date has to be in the future',
									'error'
								)
						} else {
							if (!weddingData.startDate)
								return toastHelper(
									'Wedding date is required',
									'error'
								)
							if (today > weddingData.startDate?.$d)
								return toastHelper(
									'Date has to be in the future',
									'error'
								)
							setWeddingData({
								...weddingData,
								endDate: weddingData.startDate,
							})
						}

						if (mode === 'edit' && kazooId) {
							const start = toDateValue(weddingData.startDate)
							const end = weddingData.multiDay
								? toDateValue(weddingData.endDate)
								: toDateValue(weddingData.startDate)
							try {
								const result = await dispatch(
									updateKazoo({
										kazooId,
										startDate:
											start?.toISOString?.() ?? start,
										endDate: end?.toISOString?.() ?? end,
										multiDay: weddingData.multiDay,
									})
								).unwrap()
								if (result?.success) {
									dispatch(fetchKazooDetailsNew(kazooId))
									handleNext()
								}
							} catch (err) {
								toastHelper(
									err?.message || 'Failed to update date',
									'error'
								)
							}
							return
						}

						handleNext()
					}}
				>
					{mode === 'edit' ? 'Save' : 'Next'}
				</ButtonCustom>
				{mode !== 'edit' && (
					<div className={styles.buttonContainer}>
						<Stepper activeStep={1.2} />
					</div>
				)}
			</div>
		</NewWedingModal>
	)
}

export default WeddingDate
